<template>
  <div id="speaker-add-new-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else-if="form != null && loading != 'updateScreenLoading'" key="content-loading">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-col :span="24">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("contentManagement.speakers.speakerAddUpdate.nameSurname") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.speakers.speakerAddUpdate.NamaSurnameMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.fullName" :class="$inputError('fullName', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("fullName", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="24" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("contentManagement.speakers.speakerAddUpdate.title") }}</label>
                  </div>
                  <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("contentManagement.speakers.speakerAddUpdate.company") }}</label>
                  </div>
                  <el-input v-model="form.firmName" :class="$inputError('firmName', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("firmName", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("contentManagement.speakers.speakerAddUpdate.email") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.speakers.speakerAddUpdate.emailMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.email" :class="$inputError('email', validationErrors)" clearable></el-input>
                  <span class="error">{{ $errorMessage("email", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="24" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("contentManagement.speakers.speakerAddUpdate.bio") }}</label>
                  </div>
                  <quill-editor ref="myQuillEditor" :options="editorOption" v-model="form.details" @ready="onEditorReady($event)" :class="$inputError('details', validationErrors)" />
                  <span class="error">{{ $errorMessage("details", validationErrors) }}</span>
                </div>
              </el-col>
            </el-col>
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.speakers.speakerAddUpdate.orderNo") }}</label>
                </div>
                <el-input-number v-model="form.orderNO" :max="9999" :min="1"></el-input-number>
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
              <div class="registerform-input-container mt-3">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.speakers.speakerAddUpdate.pic") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.speakers.speakerAddUpdate.picMsg") }}</span>
                    </div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="d-flex flex-row justify-content-center">
                  <el-upload :onProgress="logoProgress" class="avatar-uploader profile-picture" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=speakerPhoto&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="logoSuccess">
                    <div class="avatar-wrapper">
                      <div v-if="form.image" :style="'background-image: url(' + form.image + ')'" style=" width: 100%; height: 200px; background-size: contain; background-repeat: no-repeat; background-position: center;" class="avatar"></div>
                    </div>
                    <!-- <i v-else class="fas fa-plus avatar-uploader-icon"></i> -->
                    <div class="upload-tip-wrapper" style="left: 37px">
                      <el-button size="small" type="primary" circle icon="el-icon-upload"></el-button>
                      <div class="el-upload__tip" slot="tip">{{ $t("generic.picMsg") }}</div>
                    </div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="form.enablePresentations = !form.enablePresentations">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.speakers.speakerAddUpdate.presentations") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip> -->
                    </div>
                    <div class="text-danger" v-if="validationErrors.some(x => x.key.includes('presentations'))" v-html="$t('contentManagement.speakers.speakerAddUpdate.incorrectFields', [validationErrors.filter(x => x.key.includes('presentations')).length])"></div>
                    <span>{{ $t("contentManagement.speakers.speakerAddUpdate.presentationsMsg") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="form.enablePresentations"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="form.enablePresentations">
                    <div class="presentations-container">
                      <draggable :list="form.presentations" tag="div" handle=".el-icon-s-grid" class="list-group-o" v-bind="dragOptions">
                        <div v-for="(item, index) in form.presentations" :key="index" class="presentation">
                          <i class="el-icon-s-grid"></i>
                          <div class="presentation-title"><el-input v-model="item.title" :class="$inputError('presentations[' + index + '].Title', validationErrors)"></el-input></div>
                          <div class="btn-list">
                            <el-popconfirm @confirm="form.presentations.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                              <el-button slot="reference" type="danger" circle round size="mini" icon="fas fa-trash"></el-button>
                            </el-popconfirm>
                          </div>
                        </div>
                      </draggable>
                      <div class="presentation-add">
                        <el-button round icon="fas fa-plus" type="primary" size="mini" @click="addPresentation">{{ $t("contentManagement.speakers.speakerAddUpdate.addPresentations") }}</el-button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="contentDock = !contentDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.speakers.speakerAddUpdate.links") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip> -->
                    </div>
                    <div class="text-danger" v-if="validationErrors.some(x => x.key.includes('externalLinks'))" v-html="$t('contentManagement.speakers.speakerAddUpdate.incorrectFields', [validationErrors.filter(x => x.key.includes('externalLinks')).length])"></div>
                    <span>{{ $t("contentManagement.speakers.speakerAddUpdate.linkMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="contentDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="contentDock">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <div class="external-links-container">
                          <div class="external-link" v-for="(item, index) in form.externalLinks" :key="index" :class="item.isActive ? '' : 'passive'">
                            <div class="icon">
                              <i class="fab fa-twitter" v-if="item.type == 0" style="color:#1DA1F2;"></i>
                              <i class="fab fa-linkedin-in" v-if="item.type == 1" style="color:#0e76a8;"></i>
                              <i class="fab fa-facebook-f" v-if="item.type == 2" style="color:#3b5998;"></i>
                              <i class="fab fa-instagram" v-if="item.type == 3" style="color:#c13584;"></i>
                              <i class="fab fa-youtube" v-if="item.type == 4" style="color:#FF0000;"></i>
                              <i class="fas fa-link" v-if="item.type == 5" style="color:#03658C;"></i>
                            </div>
                            <div class="link-input">
                              <el-input v-model="item.url" :class="$inputError('externalLinks[' + index + '].Url', validationErrors)">
                                <template slot="prepend">{{ linkBase[item.type] }}</template>
                              </el-input>
                            </div>
                            <el-switch v-model="item.isActive"></el-switch>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.speakers.speakerAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.speakers.speakerAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.speakers.speakerAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.speakers.speakerAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.speakers.speakerAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.speakers.speakerAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.speakers.speakerAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.speakers.speakerAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.speakers.speakerAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import draggable from "vuedraggable";

import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor, draggable },
  name: "SpeakerAddUpdate",
  props: ["id"],
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  data() {
    return {
      contentDock: false,
      settingsDock: false,
      linkBase: ["https://www.twitter.com/", "https://www.linkedin.com/", "https://www.facebook.com/", "https://www.instagram.com/", "https://www.youtube.com/", "https://"],
      form: null,

      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ indent: "-1" }, { indent: "+1" }], [{ color: [] }, { background: [] }], ["clean"], ["link"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      loading: false,
      timeout: null,

      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false
    };
  },
  methods: {
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    addPresentation() {
      this.form.presentations.push({ title: this.$t("contentManagement.speakers.speakerAddUpdate.presentationTitle") });
    },
    selectLocalImage() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file);
        } else {
          console.warn("You could only upload images.");
        }
      };
    },
    saveToServer(file) {
      const fd = new FormData();
      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url);
          } else {
            this.$message.error(body.alert.message);
          }
        }
      };

      xhr.send(fd);
    },
    insertToEditor(url) {
      const range = this.$refs.myQuillEditor.quill.getSelection();
      this.$refs.myQuillEditor.quill.insertEmbed(range.index, "image", `${url}`);
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var dummy = JSON.parse(JSON.stringify(this.form.externalLinks));

        dummy.map(x => {
          if (x.url != null && x.url != "") {
            x.url = this.linkBase[x.type] + x.url;
          }
        });
        var res = await this.$store.dispatch("speakerAddOrUpdate", { ...this.form, categoryID: this.categoryId, externalLinks: dummy });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          this.form.externalLinks.map(x => {
            if (x.url != null && x.url != "") {
              x.url = x.url.replaceAll(this.linkBase[x.type], "");
            }
          });
          await this.$store.dispatch("getSpeakers");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },

  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getSpeaker", this.id);
        if (!res.data.alert.hasError) {
          var dummyExternalLink = res.data.data.item.externalLinks;
          dummyExternalLink.map(x => {
            console.log(x);
            if (x.url != null && x.url != "") {
              x.url = x.url.replaceAll(this.linkBase[x.type], "");
            }
          });
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          fullName: null,
          email: null,
          details: null,
          firmName: null,
          title: null,
          image: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-user.png",
          orderNO: 0,
          customTags: [],
          isActive: false,
          enableCustomTags: false,
          enablePresentations: false,
          externalLinks: [
            { type: 0, isActive: false, url: null },
            { type: 1, isActive: false, url: null },
            { type: 2, isActive: false, url: null },
            { type: 3, isActive: false, url: null },
            { type: 4, isActive: false, url: null },
            { type: 5, isActive: false, url: null }
          ],
          presentations: []
        };
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
#speaker-add-new-update {
  padding: 1rem;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.presentations-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & > .list-group-o {
    display: flex;
    flex-direction: column;
    .presentation {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      background: #f1f1f1;
      border-radius: 8px;
      padding: 10px 8px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: unset;
      }

      i {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
        margin-right: 6px;
        flex-shrink: 0;
      }

      .presentation-title {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .btn-list {
        flex-shrink: 0;
        margin-left: 12px;
      }
    }
  }
}
.presentation-add {
  display: flex;
  justify-content: flex-end;
}
.external-links-container {
  display: flex;
  flex-direction: column;
  .external-link {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: #f1f1f1;
    border-radius: 8px;
    padding: 10px 8px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    &.passive {
      background-color: #fff2f2;

      .icon {
        i {
          color: #505763 !important;
        }
      }
    }
    .icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 22px;
      color: #505763;
      margin-right: 6px;
      min-width: 30px;

      i {
        font-size: 22px;
        min-width: unset;
      }
    }
    .link-input {
      width: 100%;
    }
    .el-switch {
      margin-left: 12px;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpeakerAddUpdate.vue